import("../src/javascripts/attachments-redesign");
import("../src/javascripts/easy-toggle");
import("../src/javascripts/navigation");
import("../src/javascripts/auto-play-animations");
import("../src/javascripts/intersection-observers");
import("../src/javascripts/smooth-scroll-to-anchor");
